// 最外层管理路由
const router = {
  path: "/privacy-policy",
  name: "privacyPolicy",
  meta: {
    name: "privacyPolicy",
    title: "privacy policy",
  },
  component: (resolve) =>
    require([
      /* webpackChunkName: "admin" */ "@/views/privacy/privacy-policy.vue",
    ], resolve)
}

export default router

